import React, { FC } from 'react';
import classNames from 'classnames';

export type DropdownOption = {
    label: string;
    value: string;
};

export interface DropdownProps {
    className?: string;
    value: string;
    items: Array<DropdownOption>;
    onChange?: React.ChangeEventHandler<HTMLSelectElement>;
}

export const Dropdown: FC<DropdownProps> = ({ className, items, ...args }) => (
    <select className={classNames('sa-dropdown', className)} {...args}>
        {items.map((v) => (
            <option key={v.value} value={v.value} data-value={v}>
                {v.label}
            </option>
        ))}
    </select>
);

export interface DropdownAreaProps {
    className?: string;
    children: React.ReactNode;
}

export const DropdownArea: FC<DropdownAreaProps> = ({
    className,
    children,
}) => (
    <div className={classNames('sa-dropdown-area', className)}>{children}</div>
);
